import { BrowserStorage } from 'utils/browserStorage';

/**
 * [TEMPORARY] Accounts that are not on the new post workflow send posts for approval
 * through the legacy endpoint, which does not write the first-time flag. Remembering
 * the action locally keeps the checklist item done until every account is cut over.
 */
const getSentForApprovalKey = (userId: number, type: ApprovalType) =>
  `${BrowserStorage.keys.OnboardingChecklist.SentForApproval}-${type}-${userId}`;

export const markPostSentForApproval = (userId: number, type: ApprovalType) =>
  BrowserStorage.set(getSentForApprovalKey(userId, type), 'true');

export const hasPostSentForApproval = (userId: number, type: ApprovalType) =>
  BrowserStorage.get(getSentForApprovalKey(userId, type)) === 'true';

export const hasAnyPostSentForApproval = (userId: number) =>
  hasPostSentForApproval(userId, 'client') ||
  hasPostSentForApproval(userId, 'internal');
